
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#facebook-icon_e414ef6236c76e43__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.02 25.88C8.32 24.86 4 19.94 4 14 4 7.4 9.4 2 16 2s12 5.4 12 12c0 5.94-4.32 10.86-10.02 11.88l-.66-.54h-2.64l-.66.54Z",
  fill: "url(#facebook-icon_e414ef6236c76e43__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.678 17.36.54-3.36h-3.18v-2.34c0-.96.36-1.68 1.8-1.68h1.56V6.92c-.84-.12-1.8-.24-2.64-.24-2.76 0-4.68 1.68-4.68 4.68V14h-3v3.36h3v8.46a11.048 11.048 0 0 0 3.96 0v-8.46h2.64Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "facebook-icon_e414ef6236c76e43__b",
  x1: 27.644,
  y1: 25.165,
  x2: 27.644,
  y2: 1.996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0062E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19AFFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "facebook-icon_e414ef6236c76e43__a",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9466_1600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9466_1600",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_9466_1600)\">\r\n<path d=\"M14.02 25.88C8.32 24.86 4 19.94 4 14C4 7.4 9.4 2 16 2C22.6 2 28 7.4 28 14C28 19.94 23.68 24.86 17.98 25.88L17.32 25.34H14.68L14.02 25.88Z\" fill=\"url(#paint0_linear_9466_1600)\"/>\r\n<path d=\"M20.6781 17.3597L21.2181 13.9997H18.0381V11.6597C18.0381 10.6997 18.3981 9.97969 19.8381 9.97969H21.3981V6.91969C20.5581 6.79969 19.5981 6.67969 18.7581 6.67969C15.9981 6.67969 14.0781 8.35969 14.0781 11.3597V13.9997H11.0781V17.3597H14.0781V25.8197C14.7381 25.9397 15.3981 25.9997 16.0581 25.9997C16.7181 25.9997 17.3781 25.9397 18.0381 25.8197V17.3597H20.6781Z\" fill=\"white\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_9466_1600\" x=\"0\" y=\"0\" width=\"32\" height=\"32\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2\"/>\r\n<feGaussianBlur stdDeviation=\"2\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_9466_1600\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_9466_1600\" result=\"shape\"/>\r\n</filter>\r\n<linearGradient id=\"paint0_linear_9466_1600\" x1=\"27.6437\" y1=\"25.1654\" x2=\"27.6437\" y2=\"1.99558\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"#0062E0\"/>\r\n<stop offset=\"1\" stop-color=\"#19AFFF\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/facebook-icon.e414ef6236c76e4397bd7686c489fb04.svg"),
        {
          React: SvgFacebookIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      